<template>
  <div class="box" id="tabela-classificacao">
    <div class="box-header">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Classificação
      </h4>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>Resultado</th>
            <th>
              Escore
              <!-- <span v-b-tooltip.hover title="" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
              </span> -->
            </th>
            <th>
              Classificação
              <!-- <span v-b-tooltip.hover title="" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
              </span> -->
            </th>
            <th>Suporte</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ this.$store.state.cidade }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDoMunicipio.resultado"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDoMunicipio.escore"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <span :class="corClassificacao(dadosDoMunicipio)">
                {{ dadosDoMunicipio.classificacao }}
              </span>
            </td>
            <td>
              <div
                v-if="
                  selectedIndicador.value ==
                    'acompanhamento-por-cadastro-esus' ||
                  selectedIndicador.value ==
                    'vinculo-acompanhamento-por-cadastro-esus'
                "
                class="icon-copilot"
                @click="copilotClassificacao('municipio')"
              >
                <img src="@/assets/icones/copilot.svg" alt="" width="25px" />
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ equipe != '' ? equipe.no_equipe : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDaEquipe.resultado"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDaEquipe.escore"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <span :class="corClassificacao(dadosDaEquipe)">
                {{ dadosDaEquipe.classificacao }}
              </span>
            </td>
            <td>
              <div
                v-if="equipe != ''"
                class="icon-copilot"
                @click="copilotClassificacao('equipe')"
              >
                <img src="@/assets/icones/copilot.svg" alt="" width="25px" />
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ micro_area != '' ? 'MICROÁREA ' + micro_area : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDaMicroArea.resultado"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="dadosDaMicroArea.escore"
                :loading="loading"
                :isPercentage="false"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <span :class="corClassificacao(dadosDaMicroArea)">
                {{ dadosDaMicroArea.classificacao }}
              </span>
            </td>
            <td>
              <div
                v-if="
                  (selectedIndicador.value ==
                    'acompanhamento-por-cadastro-esus' ||
                    selectedIndicador.value ==
                      'vinculo-acompanhamento-por-cadastro-esus') &&
                  micro_area != ''
                "
                class="icon-copilot"
                @click="copilotClassificacao('microarea')"
              >
                <img src="@/assets/icones/copilot.svg" alt="" width="25px" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex align-center justify-content-between">
        <FonteEsusPecGlobal texto="Cadastros registrados até" />
        <div
          class="subtitle"
          v-if="
            selectedIndicador.value == 'acompanhamento-por-cadastro-esus' ||
            selectedIndicador.value ==
              'acompanhamento-por-parametro-de-cadastro'
          "
        >
          <div class="subtitle-item">
            <span class="green"></span> Ótimo (> 85)
          </div>
          <div class="subtitle-item">
            <span class="blue"></span> Bom (65 a 84,9)
          </div>
          <div class="subtitle-item">
            <span class="orange"></span> Suficiente (> 45 a 64,9)
          </div>
          <div class="subtitle-item">
            <span class="red"></span> Regular (< 45)
          </div>
        </div>
        <div
          class="subtitle"
          v-if="
            selectedIndicador.value ==
              'vinculo-acompanhamento-por-cadastro-esus' ||
            selectedIndicador.value ==
              'vinculo-acompanhamento-por-parametro-de-cadastro'
          "
        >
          <div class="subtitle-item">
            <span class="green"></span> Ótimo (> 8,5)
          </div>
          <div class="subtitle-item">
            <span class="blue"></span> Bom (7 a 8,5)
          </div>
          <div class="subtitle-item">
            <span class="orange"></span> Suficiente (> 5 a 6,9)
          </div>
          <div class="subtitle-item">
            <span class="red"></span> Regular (< 5)
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modal.enabled"
      hide-footer
      centered
      scrollable
      ref="modal"
      id="modal-tabela-classificacao-copilot"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <span>Suporte</span>
          <span @click="modal.enabled = false">
            <i class="icofont-close" style="cursor: pointer"></i>
          </span>
        </div>
      </template>
      <div class="body" v-if="formula.tipo == 'por-cadastro'">
        <div class="formula">
          <div class="dados-1">
            <span
              >({{ formula.acomp.qtd_acomp1_0 }} +
              {{ formula.acomp.qtd_acomp1_2 }} +
              {{ formula.acomp.qtd_acomp1_3 }} +
              {{ formula.acomp.qtd_acomp2_5 }})</span
            >
            <span class="formula-line"></span>
            <span>{{ formula.acomp.parametro }}</span>
          </div>
          <div class="dados-2">x 100 = {{ formula.acomp.resultado }}</div>
        </div>
        <table class="table table-responsive mt-4">
          <thead>
            <tr>
              <th>Resultado Acompanhamento</th>
              <th>Escore Y</th>
              <th>Classificação</th>
            </tr>
          </thead>
          <tbody>
            <tr :class="{ highlight: formula.acomp.resultado > 85 }">
              <td>>85</td>
              <td>7,00</td>
              <td>Ótimo</td>
            </tr>
            <tr
              :class="{
                highlight:
                  formula.acomp.resultado >= 65 &&
                  formula.acomp.resultado <= 84.9,
              }"
            >
              <td>65 e 84,9</td>
              <td>5,25</td>
              <td>Bom</td>
            </tr>
            <tr
              :class="{
                highlight:
                  formula.acomp.resultado >= 45 &&
                  formula.acomp.resultado <= 64.9,
              }"
            >
              <td>45 a 64,9</td>
              <td>3,50</td>
              <td>Suficiente</td>
            </tr>
            <tr :class="{ highlight: formula.acomp.resultado < 45 }">
              <td><45</td>
              <td>1,75</td>
              <td>Regular</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="body" v-if="formula.tipo == 'por-parametro'">
        <div class="formula">
          <div class="dados-2">
            {{ formula.vinc_acomp.escore_x }} +
            {{ formula.vinc_acomp.escore_y }} =
            {{ formula.vinc_acomp.resultado }}
          </div>
        </div>
        <table class="table table-responsive mt-4">
          <thead>
            <tr>
              <th>Escore Final</th>
              <th>Classificação Final</th>
            </tr>
          </thead>
          <tbody>
            <tr :class="{ highlight: formula.vinc_acomp.resultado > 8.5 }">
              <td>>8,5</td>
              <td>Ótimo</td>
            </tr>
            <tr
              :class="{
                highlight:
                  formula.vinc_acomp.resultado >= 7 &&
                  formula.vinc_acomp.resultado <= 8.5,
              }"
            >
              <td>7 a 8,5</td>
              <td>Bom</td>
            </tr>
            <tr
              :class="{
                highlight:
                  formula.vinc_acomp.resultado >= 5 &&
                  formula.vinc_acomp.resultado <= 6.9,
              }"
            >
              <td>5 e 6,9</td>
              <td>Suficiente</td>
            </tr>
            <tr :class="{ highlight: formula.vinc_acomp.resultado < 5 }">
              <td><5</td>
              <td>Regular</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'TabelaClassificacao',
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dadosDoMunicipio: {
      type: [String, Object],
      default: '',
    },
    dadosDaEquipe: {
      type: [String, Object],
      default: '',
    },
    dadosDaMicroArea: {
      type: [String, Object],
      default: '',
    },
    equipe: {
      type: [String, Object],
      default: () => {},
    },
    micro_area: {
      type: [String],
      default: '',
    },
    selectedIndicador: {
      type: [String, Object],
      default: () => {},
    },
  },
  data() {
    return {
      modal: {
        enabled: false,
        type: '',
      },
      formula: {
        tipo: 'por-cadastro',
        acomp: {
          parametro: 'Parâmetro',
          qtd_acomp1_0: 'A',
          qtd_acomp1_2: 'B',
          qtd_acomp1_3: 'C',
          qtd_acomp2_5: 'D',
          resultado: '',
        },
        vinc_acomp: {
          escore_x: 'X',
          escore_y: 'Y',
          resultado: '',
        },
      },
    }
  },
  mounted() {},
  watch: {},
  methods: {
    resetFormula() {
      this.formula = {
        tipo: 'por-cadastro',
        acomp: {
          parametro: 'Parâmetro',
          qtd_acomp1_0: 'A',
          qtd_acomp1_2: 'B',
          qtd_acomp1_3: 'C',
          qtd_acomp2_5: 'D',
          resultado: '',
        },
        vinc_acomp: {
          escore_x: 'X',
          escore_y: 'Y',
          resultado: '',
        },
      }
    },

    corClassificacao(item) {
      switch (item.classificacao) {
        case 'Ótimo':
          return 'green'
          break
        case 'Bom':
          return 'blue'
          break
        case 'Suficiente':
          return 'orange'
          break
        case 'Regular':
          return 'red'
          break
        default:
          break
      }
    },

    copilotClassificacao(item) {
      // this.resetFormula()
      this.modal.enabled = true
      if (item == 'municipio' && this.dadosDoMunicipio.dados != undefined) {
        if (
          this.dadosDoMunicipio.dados.tipo == 'acompanhamento-por-cadastro-esus'
        ) {
          this.formula.tipo = 'por-cadastro'
          this.formula.acomp.parametro = this.dadosDoMunicipio.dados.parametro
          this.formula.acomp.qtd_acomp1_0 =
            this.dadosDoMunicipio.dados.qtd_acomp1_0
          this.formula.acomp.qtd_acomp1_2 =
            this.dadosDoMunicipio.dados.qtd_acomp1_2
          this.formula.acomp.qtd_acomp1_3 =
            this.dadosDoMunicipio.dados.qtd_acomp1_3
          this.formula.acomp.qtd_acomp2_5 =
            this.dadosDoMunicipio.dados.qtd_acomp2_5
          this.formula.acomp.resultado = this.dadosDoMunicipio.resultado
        }
        if (
          this.dadosDoMunicipio.dados.tipo ==
          'vinculo-acompanhamento-por-cadastro-esus'
        ) {
          this.formula.tipo = 'por-parametro'
          this.formula.vinc_acomp.escore_x =
            this.dadosDoMunicipio.dados.escore_x
          this.formula.vinc_acomp.escore_y =
            this.dadosDoMunicipio.dados.escore_y
          this.formula.vinc_acomp.resultado = this.dadosDoMunicipio.escore
        }
      }

      if (item == 'equipe' && this.dadosDaEquipe.dados != undefined) {
        if (
          this.dadosDaEquipe.dados.tipo == 'acompanhamento-por-cadastro-esus' ||
          this.dadosDaEquipe.dados.tipo ==
            'acompanhamento-por-parametro-de-cadastro'
        ) {
          this.formula.tipo = 'por-cadastro'
          this.formula.acomp.parametro = this.dadosDaEquipe.dados.parametro
          this.formula.acomp.qtd_acomp1_0 =
            this.dadosDaEquipe.dados.qtd_acomp1_0
          this.formula.acomp.qtd_acomp1_2 =
            this.dadosDaEquipe.dados.qtd_acomp1_2
          this.formula.acomp.qtd_acomp1_3 =
            this.dadosDaEquipe.dados.qtd_acomp1_3
          this.formula.acomp.qtd_acomp2_5 =
            this.dadosDaEquipe.dados.qtd_acomp2_5
          this.formula.acomp.resultado = this.dadosDaEquipe.resultado
        }
        if (
          this.dadosDaEquipe.dados.tipo ==
            'vinculo-acompanhamento-por-cadastro-esus' ||
          this.dadosDaEquipe.dados.tipo ==
            'vinculo-acompanhamento-por-parametro-de-cadastro'
        ) {
          this.formula.tipo = 'por-parametro'
          this.formula.vinc_acomp.escore_x = this.dadosDaEquipe.dados.escore_x
          this.formula.vinc_acomp.escore_y = this.dadosDaEquipe.dados.escore_y
          this.formula.vinc_acomp.resultado = this.dadosDaEquipe.escore
        }
      }

      if (item == 'microarea' && this.dadosDaMicroArea.dados != undefined) {
        if (
          this.dadosDaMicroArea.dados.tipo == 'acompanhamento-por-cadastro-esus'
        ) {
          this.formula.tipo = 'por-cadastro'
          this.formula.acomp.parametro = this.dadosDaMicroArea.dados.parametro
          this.formula.acomp.qtd_acomp1_0 =
            this.dadosDaMicroArea.dados.qtd_acomp1_0
          this.formula.acomp.qtd_acomp1_2 =
            this.dadosDaMicroArea.dados.qtd_acomp1_2
          this.formula.acomp.qtd_acomp1_3 =
            this.dadosDaMicroArea.dados.qtd_acomp1_3
          this.formula.acomp.qtd_acomp2_5 =
            this.dadosDaMicroArea.dados.qtd_acomp2_5
          this.formula.acomp.resultado = this.dadosDaMicroArea.resultado
        }
        if (
          this.dadosDaMicroArea.dados.tipo ==
          'vinculo-acompanhamento-por-cadastro-esus'
        ) {
          this.formula.tipo = 'por-parametro'
          this.formula.vinc_acomp.escore_x =
            this.dadosDaMicroArea.dados.escore_x
          this.formula.vinc_acomp.escore_y =
            this.dadosDaMicroArea.dados.escore_y
          this.formula.vinc_acomp.resultado = this.dadosDaMicroArea.escore
        }
      }
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />

<style scoped lang="scss">
#tabela-classificacao {
  .subtitle {
    .subtitle-item {
      font-size: 14px;
      span {
        width: 15px;
        height: 15px;
        &.green {
          background: green;
        }
        &.blue {
          background: blue;
        }
        &.orange {
          background: orange;
        }
        &.red {
          background: red;
        }
      }
    }
  }
  .icon-copilot {
    img {
      background: #f7f7f7;
      color: #00aeef;
      border-radius: 10px;
      text-align: center;
      width: 40px;
      padding: 10px;
      cursor: pointer;
    }
  }
}

#modal-tabela-classificacao-copilot {
  .formula {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    .dados-1 {
      display: flex;
      flex-direction: column;
      text-align: center;
    }
    .formula-line {
      width: 200px;
      background: #000;
      height: 1px;
    }
  }
  .highlight {
    background-color: #f0f8ff;
    font-weight: bold;
  }
  table {
    th {
      font-weight: normal;
    }
  }
}
</style>
